import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid, Typography, Button } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4)
  },
  content: {
    paddingTop: 150,
    textAlign: 'center'
  },
  image: {
    marginTop: 50,
    display: 'inline-block',
    maxWidth: '100%',
    width: 560
  }
}));

const NotFound = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Grid
        container
        justify="center"
        spacing={4}
      >
        <Grid
          item
          lg={6}
          xs={12}
        >
          <div className={classes.content}>
            <Typography variant="h1">
              Thank you for your interest
            


            </Typography>
            <br></br>
            
            <Typography variant="subtitle2">
              You have tried to login with your Microsoft Office account but your ID
              is not included in our current list of beta testers! 
            </Typography>
            <br></br>
            <Button
              color="primary"
              fullWidth
              href="https://auicareerspark.com"
              size="large"
              variant="contained"
            >
              Back to Home
            </Button>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default NotFound;
